<template>
  <div id="layout">
    <el-container style="height: 100%;">
      <el-header id="header" style="background-color: #0789EA; color: #fff;">
        <ul class="personal">
          <li style="color: #fff;">
            <h1>桃花汽车导购管理平台</h1>
          </li>
          <li style="float: right">
            <!-- <el-dropdown>
              <i class="el-icon-setting" style="margin-right: 15px; color: #fff;"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>查看</el-dropdown-item>
                <el-dropdown-item>新增</el-dropdown-item>
                <el-dropdown-item>删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
<!--            <span style="font-weight: bold;">{{name}}</span>-->
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link" style="font-weight: bold;color: white;">
                {{name}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </el-header>
      <el-container style="overflow :auto;">
        <transition name="el-fade-in-linear">
          <el-aside
            v-show="show"
            class="transition-box"
            style="border-right: solid 1px #e6e6e6; width: 280px;"
          >
            <el-menu default-active="0-1" style="border: none;" active-text-color="#fff">
              <el-menu-item index="0-1" @click="linkTo('/index')">
                <template slot="title">
                  <i class="el-icon-s-home"></i>
                  <span>首页</span>
                  <span
                    @click.stop="show = false"
                    class="el-icon-circle-close"
                    size="medium"
                    style="display: inline-block; z-index: 100; float: right; clear: both; margin-top: 19px;"
                  />
                </template>
              </el-menu-item>
              <el-menu-item index="0-2" @click="linkTo('/channel')" v-if="this.checkMenuPermission('channel:manage')">
                <i class="el-icon-guide"></i>
                渠道管理
              </el-menu-item>
              <el-submenu index="0-3" v-if="this.checkMenuPermission('user:manage')">
                <template slot="title">
                  <i class="el-icon-user"></i>
                  <span>会员管理</span>
                </template>
                <el-menu-item index="0-3-1" @click="linkTo('/user/list')"   v-if="this.checkMenuPermission('user:manage:list')">
                  <i class="el-icon-user"></i>
                  会员管理
                </el-menu-item>
                <el-menu-item index="0-3-2" @click="linkTo('/user/userInfo')" v-if="this.checkMenuPermission('user:manage:audit')">
                  <i class="el-icon-set-up"></i>
                  个人信息审核
                </el-menu-item>
              </el-submenu>
              <el-menu-item index="0-4" @click="linkTo('/advance-order/guideBooking/list')" v-if="this.checkMenuPermission('guidebooking:manage')">
                <i class="el-icon-s-order"></i>
                导购单
              </el-menu-item>
              <el-menu-item index="0-5" @click="linkTo('/advance-order/carloan/list')" v-if="this.checkMenuPermission('carload:manage')">
                <i class="el-icon-stopwatch"></i>
                车贷单
              </el-menu-item>
              <el-menu-item index="0-6" @click="linkTo('/integral/list')" v-if="this.checkMenuPermission('integral:manage')">
                <i class="el-icon-present"></i>
                积分兑换管理
              </el-menu-item>
              <el-menu-item index="0-7" @click="linkTo('/gift_order/gift/list')" v-if="this.checkMenuPermission('giftorder:manage')">
                <i class="el-icon-set-up"></i>
                礼品单管理
              </el-menu-item>
              <!-- <el-submenu index="0-8"  v-if=" role === 1">
                <template slot="title">
                  <i class="el-icon-setting"></i>
                  <span>推送管理</span>
                </template>
                <el-menu-item index="0-8-1" @click="linkTo('/push/list')">
                  <i class="el-icon-set-up"></i>
                  推送管理
                </el-menu-item>
                <el-menu-item index="0-8-2" @click="linkTo('/push/newPushList')">
                  <i class="el-icon-s-operation"></i>
                  任务推送管理
                </el-menu-item>
              </el-submenu> -->
              <el-menu-item index="0-8"  @click="linkTo('/push/newPushList')" v-if="this.checkMenuPermission('push:manage')">
                <i class="el-icon-s-operation"></i>
                 任务推送管理
              </el-menu-item>
              <el-menu-item index="0-9" @click="linkTo('/front/statistics')" v-if="this.checkMenuPermission('statistics:manage')">
                <i class="el-icon-guide"></i>
                数据统计
              </el-menu-item>
              <el-submenu index="1" v-if="this.checkMenuPermission('front:manage')">
                <template slot="title">
                  <i class="el-icon-mobile-phone"></i>
                  <span>前端管理</span>
                </template>
                <el-menu-item index="1-1" @click="linkTo('/front/advertise/list')" v-if="this.checkMenuPermission('front:manage:advertise')">
                  <i class="el-icon-film"></i>
                  广告栏
                </el-menu-item>
                <el-menu-item index="1-2" @click="linkTo('/front/home/brand')" v-if="this.checkMenuPermission('front:manage:brand')">
                  <i class="el-icon-film"></i>
                  首页品牌
                </el-menu-item>
                <el-menu-item index="1-3" @click="linkTo('/front/activity/list')" v-if="this.checkMenuPermission('front:manage:activity:hot')">
                  <i class="el-icon-film"></i>
                  热门活动
                </el-menu-item>
<!--                <el-submenu index="1-5" v-if="this.checkMenuPermission('front:manage:activity')">-->
<!--                  <template slot="title">-->
<!--                    <i class="el-icon-mobile"></i>-->
<!--                    活动管理-->
<!--                  </template>-->
<!--                  <el-menu-item index="1-5-1" @click="linkTo('/front/activity/list')" v-if="this.checkMenuPermission('front:manage:activity:hot')">-->
<!--                    <i class="el-icon-mobile"></i>-->
<!--                    热门活动-->
<!--                  </el-menu-item>-->
<!--                    <el-menu-item index="1-5-2" @click="linkTo('/front/activityrule/list')" v-if="this.checkMenuPermission('front:manage:activity:rule')">-->
<!--                    <i class="el-icon-mobile"></i>-->
<!--                    活动规则-->
<!--                  </el-menu-item>-->
<!--                  &lt;!&ndash; <el-menu-item index="1-5-3" @click="linkTo('/front/activityforword/list')">-->
<!--                    <i class="el-icon-mobile"></i>-->
<!--                    活动转发-->
<!--                  </el-menu-item>-->
<!--                  <el-menu-item index="1-5-4" @click="linkTo('/front/pointfabulou/list')">-->
<!--                    <i class="el-icon-mobile"></i>-->
<!--                    点赞管理-->
<!--                  </el-menu-item>&ndash;&gt;-->
<!--                </el-submenu>-->

                <el-menu-item index="1-6" @click="linkTo('/front/agreement/list')" v-if="this.checkMenuPermission('front:manage:agreement')">
                  <i class="el-icon-document"></i>
                  协议管理
                </el-menu-item>
                <el-menu-item index="1-7" @click="linkTo('/front/wechat/setting')" v-if="this.checkMenuPermission('front:manage:setting')">
                  <i class="el-icon-document"></i>
                  小程序图片
                </el-menu-item>
              </el-submenu>
              <el-submenu index="2" v-if="this.checkMenuPermission('car:manage')">
                <template slot="title">
                  <i class="el-icon-truck"></i>
                  <span>汽车管理</span>
                </template>
                <el-menu-item index="2-1" @click="linkTo('/car/brand/list')" v-if="this.checkMenuPermission('car:manage:brand')">
                  <i class="el-icon-s-flag"></i>
                  品牌管理
                </el-menu-item>
                <el-menu-item index="2-2" @click="linkTo('/car/category/list')" v-if="this.checkMenuPermission('car:manage:category')">
                  <i class="el-icon-files"></i>
                  车型管理
                </el-menu-item>
              </el-submenu>
              <el-submenu index="3" v-if="this.checkMenuPermission('popularize:manage')">
                <template slot="title">
                  <i class="el-icon-magic-stick"></i>
                  <span>推广管理</span>
                </template>
                <el-menu-item index="3-1" @click="linkTo('/popularize/poster/list')" v-if="this.checkMenuPermission('popularize:manage:poster')">
                  <i class="el-icon-picture-outline"></i>
                  海报管理
                </el-menu-item>
                <el-menu-item index="3-2" @click="linkTo('/popularize/article/list')" v-if="this.checkMenuPermission('popularize:manage:article')">
                  <i class="el-icon-tickets"></i>
                  文章管理
                </el-menu-item>
                <el-menu-item index="3-3" @click="linkTo('/popularize/writings/list')" v-if="this.checkMenuPermission('popularize:manage:writings')">
                  <i class="el-icon-tickets"></i>
                  海报二维码文章
                </el-menu-item>
              </el-submenu>
              <el-submenu index="9" v-if="this.checkMenuPermission('system:manage')">
                <template slot="title">
                  <i class="el-icon-setting"></i>
                  <span>系统管理</span>
                </template>
                <el-menu-item v-if="this.checkMenuPermission('system:manage:dept')" index="9-1" @click="linkTo('/system/dept/list')">
                  <i class="el-icon-set-up"></i>
                  部门管理
                </el-menu-item>
                <el-menu-item v-if="this.checkMenuPermission('system:manage:role')" index="9-2" @click="linkTo('/system/role/list')">
                  <i class="el-icon-s-custom"></i>
                  角色管理
                </el-menu-item>
                <el-menu-item v-if="this.checkMenuPermission('system:manage:user')" index="9-3" @click="linkTo('/system/sysuser/list')">
                  <i class="el-icon-user"></i>
                  用户管理
                </el-menu-item>
                <el-menu-item v-if="this.checkMenuPermission('system:manage:menu')" index="9-4" @click="linkTo('/system/menu/list')">
                  <i class="el-icon-menu"></i>
                  菜单管理
                </el-menu-item>
              </el-submenu>
              <el-menu-item index="10-1" @click="linkTo('/feedback/list')" v-if="this.checkMenuPermission('feedback:manage')">
                <i class="el-icon-stopwatch"></i>
                反馈管理
              </el-menu-item>
            </el-menu>
          </el-aside>
        </transition>
        <el-container style="padding: 0; margin: 0;">
          <el-main style="padding: 10px;">
            <div
              style="max-height: 60px; line-height: 50px; padding-left: 10px;"
              v-if="show == false"
            >
              <span
                :class="{'el-icon-s-fold': show, 'el-icon-s-unfold': !show}"
                @click="show = !show"
                style="cursor: pointer;"
              ></span>
            </div>
            <transition mode="out-in">
              <router-view></router-view>
            </transition>
          </el-main>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  export default {
    created () {
      // this.$router.push('/index');

    },
    data () {
      const item = {
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      };
      return {
        show: true,
        tableData: Array(20).fill(item),
        name : sessionStorage.getItem("name"),
        role : parseInt(sessionStorage.getItem("role")),
        // name : "张发荣",
        // role : 1

      }
    },
    methods: {
      linkTo(url) {
        this.$router.push({path: url});
      },
      handleCommand(command) {
        this.$router.push({path: '/login'});
      },
      checkMenuPermission(perms) {
        let menuPermsList = sessionStorage.getItem("menuPermsList");
        if (menuPermsList.indexOf(perms) != -1) {
          return true
        } else {
          return false;
        }
      }
    }
  }
</script>

<style scoped>
  #layout {
    height: 100%;
  }

  .el-menu-item.is-active {
    background-color: #0789EA!important;
    opacity: 0.7 !important;
  }
</style>

<style>

  * {
    margin: 0px;
    padding: 0px;
  }

  .el-row {
    margin-bottom: 5px;
  }

  .personal li {
    float: left;
    list-style: none;
  }

  .padding-10px {
    padding: 10px;
  }

  #header {
    max-height: 60px;
    line-height: 60px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .05);
  }

</style>



// WEBPACK FOOTER //
// src/views/layout/layout.vue